import { api } from "../lib/api";
import type { GetReadyTasksResponse } from "../types/task";

/**
 * Get the Get Ready tasks feed for the current user.
 * @deprecated M011/S02 removed the GetReady call site — GetReadyPage now reads from
 * useJourneyProgress exclusively. S05 owns final removal of this function and a
 * no-new-imports CI rule to prevent re-introduction of the /api/tasks path.
 */
export async function getGetReadyTasks(): Promise<GetReadyTasksResponse> {
	const response = await api.get<GetReadyTasksResponse>("/api/tasks");
	return response.data;
}
